'use client';
import { useContext, useState } from 'react';
import { QuotesContext } from './index.client';
import { ResolutionTabs } from '@/components/atoms/Tabs/ResolutionTabs';
import dynamic from 'next/dynamic';
import { ResolutionString } from '@/public/assets/charting_library/charting_library';
import { RectangleSkeleton } from '@/components/atoms/Skeleton';

const TradingView = dynamic(() => import('../TradingView'), {
  ssr: false,
  loading: () => <RectangleSkeleton height={687} width={700} />
});

const TABS = [
  { label: '分時', value: 1 },
  { label: '日K', value: '1D' },
  { label: '週K', value: '1W' },
  { label: '月K', value: '1M' },
  { label: '5分', value: 5 },
  { label: '10分', value: 10 },
  { label: '15分', value: 15 },
  { label: '30分', value: 30 },
  { label: '60分', value: 60 }
];

const DEFAULT_TAB_INDEX = 1;
type TradingViewChartProps = {
  symbol: string;
  resolution: ResolutionString;
};

const ForexChart = () => {
  const context = useContext(QuotesContext);
  const symbol = context?.store?.symbol || 'GI:DXY:INDEX';

  const [resolution, setResolution] = useState<number | string>(TABS[DEFAULT_TAB_INDEX].value);

  const onClick = (index: number) => {
    setResolution(TABS?.[index]?.value);
  };

  return (
    <div className='flex-1'>
      <ResolutionTabs tabs={TABS} onClick={onClick} defaultIndex={DEFAULT_TAB_INDEX} />
      <div className='mt-4'>
        <TradingView symbol={symbol} resolution={resolution as ResolutionString} />
      </div>
    </div>
  );
};

export default ForexChart;
